module.exports = __webpack_public_path__ + "img/dai.218335e1.png";